import { FaHashtag, FaListUl } from 'react-icons/fa';

export const UserPageLinks = [
  { icon: FaHashtag, name: 'Főoldal', href: '/' }, //FaHome
  { icon: FaListUl, name: 'Termékek', href: '/products' },
];
